<script setup>
import { computed } from 'vue'
import FormProgress from '@/components/Atoms/FormProgress.vue'

const props = defineProps({
	// Seat usage: { used, pending, occupied, max, atLimit }. `occupied` counts
	// distinct people across the whole account (members plus pending invitees),
	// which is how the server gates invitations.
	usage: {
		type: Object,
		default: () => ({ used: 0, pending: 0, occupied: 0, max: 0 }),
	},
	// With several workspaces the count needs the reminder that a person on two
	// workspaces is still one seat; with one workspace it would be noise.
	multiProject: {
		type: Boolean,
		default: false,
	},
})

const pending = computed(() => props.usage?.pending || 0)
const occupied = computed(() => props.usage?.occupied || 0)
const max = computed(() => props.usage?.max || 0)
</script>

<template>
	<div v-if="max" class="flex flex-wrap items-center gap-x-3 gap-y-1 w-full" data-testid="team-seat-usage">
		<FormProgress
			:value="occupied"
			:secondary-value="occupied"
			:max="max"
			height-class="h-1.5"
			track-class="bg-surface-2"
			class="flex-1 min-w-[72px] max-w-[220px]"
		/>
		<span class="text-sm text-surface-text-2 whitespace-nowrap">{{ occupied }} of {{ max }} seats used</span>
		<span v-if="pending > 0" class="text-sm text-surface-6 whitespace-nowrap">
			· {{ pending }} {{ pending === 1 ? 'invitation' : 'invitations' }} pending
		</span>
		<span v-if="multiProject" class="text-sm text-surface-6 whitespace-nowrap">
			· counts people, not workspaces
		</span>
	</div>
</template>
